import {connect} from "react-redux";
import SearchResult from "../../_data/models/SearchResult";
import {Map} from "immutable";
import SearchTrendingComponent from "../components/SearchTrendingComponent";

interface Props {
    results: Map<number, SearchResult>;
}

const mapStateToProps = (state, props: Props) => {
    const {results} = props;

    return {
        styles: results.filter(r => r.type == 'Style'),
        specials: results.filter(r => r.type == 'Special'),
        shops: results.filter(r => r.type == 'Salon'),
        users: results.filter(r => r.type == 'User'),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

const SearchTrendingContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(SearchTrendingComponent);
export default SearchTrendingContainer;


// WEBPACK FOOTER //
// ./app/client/search/containers/SearchTrendingContainer.tsx